<template>
    <div id="loading" @touchmove.prevent v-show="visible" >
        <div class="box">
            <div class='img'><!--<img src="../../assets/images/img_15.png" style="left:90%;top:10%;position:absolute;width:15px;height:15px;" @click="close">--></div>
            <div class='main'>
                <!-- <div class='msg'><span>亲爱的钱大师用户们，</span><br>为了您有一个愉快的试玩体验，您需要更换此地址</div> -->
                <div class='msg'><span>亲爱的钱大师用户：</span><br>检测到您已经通过实名认证，请您再次仔细阅读我们的打款协议并点击同意</div>
                <!--<div class='urlButton'><span class='url'>{{url}}</span></div>-->
                <!-- <div class='msg3'><span>先卸载本机已安装的钱大师，</span><br><span>再重新安装新地址，该地址长期稳定不掉，谢谢配合！！！</span><br></div> -->
                <div class="msg3" style="margin-top:1.21333rem;" ><a @click="toUserAgreement" ><b style="color:red;">《钱大师打款服务协议》</b></a></div>
                <div class='lastButton' @click="agree"><div class='msg2'>同意协议</div></div>
            </div>>
        </div>
    </div>
</template>

<script>
import clientApi from '../../assets/js/clientApi.js';
import router from '../../router.js'
// var that = this;
    export default {
        components:{

        },
        data() {
            return {
                visible: false,
                url: ''
            }
        },
        methods: {
            toUserAgreement:function(){
                router.push({'path':'/personal/noviceGuide/userAgreement'});
                this.visible = false;
            },
            agree:function(){
                this.$loading(true);
                this.$http.POSTS("System/userAgreement",{},(res)=>{
                    this.$loading(false);
                    if(res.flag === 'error'){
                        Dialog.alert({
                            title: '提示',
                            message: res.msg,
                        })
                        return ;
                    }
                    location.reload();
                    this.visible = false
                })
            }
        },
    }
</script>

<style lang="less" scoped>
    #loading{
        position:fixed;
        left:0;
        top:0;
        width:100%;
        height:100%;
        z-index:10;
        background:rgba(0,0,0,0.5);;
        .box{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            width: 248px;
            height: 390px;
            
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            // justify-content: center;
            align-items: center;
            .img{
                width: 248px;
                height: 93px;
                background-image: url('../../assets/images/img_88.png');
                background-repeat:round;
                z-index: 9;
            }
            .main{  
                width:248px;
                height:318px;
                background: rgba(255,255,255,1);
                display: flex;
                flex-direction: column;
                align-items: center;
                .msg{
                    margin-top: 24px;
                    width:218px;
                    height:66px;
                    font-size:16px;
                    font-weight:900;
                    color:rgba(51,51,51,1);
                    line-height:26px;
                    text-align:center;
                }
                .urlButton{
                    margin-top:8px;
                    background:rgba(235,235,235,1);
                    border-radius:4px;
                    width:218px;
                    height:46px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .url{
                        margin: 12px 8px;
                        width:202px;
                        height:22px;
                        font-size:16px;
                        font-weight:500;
                        color:rgba(229,1,19,1);
                        line-height:22px;
                        text-align:center;
                        word-break:keep-all;
                        white-space:nowrap;
                        overflow:hidden;
                        text-overflow:ellipsis;
                    }
                }
                .msg3{
                    margin-top: 8px;
                    width:218px;
                    height:36px;
                    font-size:16px;
                    font-weight:900;
                    color:rgba(51,51,51,1);
                    line-height:33px;
                    text-align:center;
                }
                .lastButton{
                    margin-top:18px;
                    width:160px;
                    height:38px;
                    background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
                    box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
                    border-radius:18px;
                    .msg2{
                        margin:8px 48px;
                        width:64px;
                        height:22px;
                        font-size:16px;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        line-height:22px;
                    }
                }
            }
        }
    }
</style>